import {AxiosResponse} from 'axios';
import EfeApi from 'services/api/Api';
import {
    Catalog,
    CatalogResponse,
    EfeCatalog,
    EfeResponse,
    ResponseValues,
    SepomexCatalogResponse,
} from 'commons/models';

import {toEfeCatalogWithValues} from 'commons/parsers';
import {Utils} from 'commons';

/**
 * Get Catalog List
 * @returns {any}: Definition Catalog List
 */
async function getAll(): Promise<EfeResponse<Array<Catalog>>> {
    try {
        return await EfeApi.Catalogs.get<CatalogResponse>(
            '/api/v1/catalogs'
        ).then((res: AxiosResponse<CatalogResponse>) => {
            return Promise.resolve({
                data: res.data.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

/**
 * Get Catalog By Keys
 * @param {string} key: String separated by semicolon for multiple catalogs
 * @param {string} orderBy: key of catalog to use at ordering
 * @param {true} dev: get dummy values
 * @returns {Promise<EfeResponse<Array<EfeCatalog>>>}
 */
async function getCatalog(
    key: string,
    orderBy?: string,
    dev?: boolean
): Promise<EfeResponse<EfeCatalog>> {
    try {
        return await EfeApi.Catalogs.get<ResponseValues>(
            '/api/v1/catalogs/values',
            {
                params: {
                    catalogKeys: key,
                    order: orderBy || 'cveCatalog',
                    devValues: dev || false,
                },
            }
        ).then((res) => {
            const axiosResponse: AxiosResponse<ResponseValues> = res;
            const responseCatalogValues = axiosResponse.data;
            // Obtain first catalog only.
            const firstCatalog = responseCatalogValues.catalogs.shift();

            // Reject when undefined
            if (!Utils.functions.notEmpty(firstCatalog)) {
                return Promise.reject({
                    status: 'Error',
                    success: true,
                    code: res.status,
                    message: `No se encontr\u00f3 informaci\u00f3n del cat\u00e1logo ${key}`,
                });
            }
            // Parse and resolve
            const parsed: EfeCatalog = toEfeCatalogWithValues(firstCatalog);
            return Promise.resolve({
                data: parsed,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getCatalogs(
    key: string,
    orderBy?: string,
    dev?: boolean
): Promise<EfeResponse<EfeCatalog[]>> {
    try {
        return await EfeApi.Catalogs.get<ResponseValues>(
            '/api/v1/catalogs/values',
            {
                params: {
                    catalogKeys: key,
                    order: orderBy || 'cveCatalog',
                    devValues: dev || false,
                },
            }
        ).then((res) => {
            const axiosResponse: AxiosResponse<ResponseValues> = res;
            const catalogs = axiosResponse?.data.catalogs;
            // Obtain first catalog only.
            // const firstCatalog = responseCatalogValues.catalogs.shift();

            // Reject when undefined
            if (!Utils.functions.notEmpty(catalogs)) {
                return Promise.reject({
                    status: 'Error',
                    success: true,
                    code: res.status,
                    message: `No se encontr\u00f3 informaci\u00f3n del cat\u00e1logo ${key}`,
                });
            }
            // Parse and resolve
            const listCatalogs = [];
            for(const catalog of catalogs) {
                const parsed: EfeCatalog = toEfeCatalogWithValues(catalog);
                listCatalogs.push(parsed);
            }
            return Promise.resolve({
                data: listCatalogs,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getSepomexCatalog(
    request: string
): Promise<EfeResponse<SepomexCatalogResponse>> {
    try {
        return await EfeApi.Catalogs.get<SepomexCatalogResponse>(
            '/api/v1/catalogs/sepomex',
            {params: {zipCode: request}}
        ).then((res: AxiosResponse<SepomexCatalogResponse>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    getAll,
    getValuesFrom: getCatalog,
    getCatalogs,
    getSepomexCatalog
};
